import { Build } from "@stencil/core";
import Swiper from "swiper";
import { Autoplay, Navigation, Pagination, Thumbs } from "swiper/modules";
export async function configureSlider(swiperElement, configuration) {
    if (!Build.isBrowser) {
        return;
    }
    let singleSlide = false;
    if (swiperElement && swiperElement.querySelectorAll('.carousel-slide').length <= 1) {
        singleSlide = true;
    }
    Swiper.use([Autoplay, Navigation, Pagination, Thumbs]);
    const showHideNavigation = (swiper) => {
        if (singleSlide || (swiper.isBeginning && swiper.isEnd)) {
            swiperElement.classList.add('hide-navigation');
        }
        else {
            swiperElement.classList.remove('hide-navigation');
        }
    };
    const swiper = new Swiper(swiperElement, Object.assign({}, {
        loop: !singleSlide,
        init: false,
        watchOverflow: true,
        speed: 600,
        containerModifierClass: 'carousel-',
        wrapperClass: 'carousel-inner',
        slideClass: 'carousel-slide',
        slideActiveClass: 'active',
        pagination: {
            el: '.carousel-indicators',
            clickable: true,
            bulletElement: 'li',
            bulletClass: 'carousel-indicator',
            bulletActiveClass: 'active',
        },
        navigation: {
            prevEl: '.carousel-control-left',
            nextEl: '.carousel-control-right',
            disabledClass: 'disabled'
        },
        on: {
            init: (swiper) => showHideNavigation(swiper),
            resize: (swiper) => showHideNavigation(swiper)
        }
    }, configuration));
    swiper.init();
    return swiper;
}
//# sourceMappingURL=configure-slider.js.map
